<template>
  <!--新增服务人员账号-->
  <el-dialog title="新增账号" :visible.sync="showCreate" width="30%" destroy-on-close @close="$emit('update:show',false)">
    <el-form ref="ruleForm" :model="account" class="dialog-form" :rules="rules">
      <el-form-item label="账号" :label-width="formLabelWidth" prop="account">
        <el-input v-model.trim="account.account" type="text" autocomplete="off" />
      </el-form-item>
      <el-form-item label="关联OA账号" :label-width="formLabelWidth" prop="customer_number">
        <el-input v-model="account.customer_number" type="text" autocomplete="off" />
      </el-form-item>
      <el-form-item label="使用者昵称" :label-width="formLabelWidth" prop="name">
        <el-input v-model="account.name" type="text" autocomplete="off" />
      </el-form-item>
      <el-form-item label="初始密码" :label-width="formLabelWidth" prop="checkPsw">
        jinduo{{ new Date()|parseTime('{y}{m}{d}') }}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import {
  createAdminAccount
} from '@/api/adminAccount'
import { fetchStoreList } from '@/api/store'
export default {

  props: {
    show: {
      type: Boolean,
      default: false
    },
    roles: {
      type: Array,
      default: () => []
    },
    isDealer: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      loading: false,
      remoteLoading: false,
      storeList: [],
      isShowStoreList: false,
      showCreate: this.show, // 打开密码修改
      account: { // 当前选中账号信息
        account: '',
        name: '',
        role_id: '',
        platform_ids: [],
        store_id: undefined
      },
      formLabelWidth: '100',
      rules: {
        account: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }]
      }
    }
  },

  watch: {
    show(n) {
      this.showCreate = this.show
      if (!n) {
        this.account = { // 当前选中账号信息
          account: '',
          name: '',
          role_id: '',
          platform_ids: [],
          store_id: undefined
        }
      }
    }
  },

  methods: {
    onSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const payload = {
            account: this.account.account,
            real_name: this.account.name,
            customer_number: this.account.customer_number,
            is_dealer: this.isDealer
          }

          if (this.account.store_id) {
            payload.store_id = this.account.store_id
          }
          this.loading = true
          createAdminAccount(payload).then(response => {
            console.log(response)
            // 关闭弹层
            this.$emit('update:show', false)
            this.$emit('update')
            this.$message({
              message: '创建账号成功',
              type: 'success',
              duration: 3 * 1000
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // select远程搜索
    remoteMethod(query) {
      this.storeList = []
      if (query !== '') {
        this.remoteLoading = true
        this.fetchStoreList({ store_name: query })
      } else {
        // this.options = [];
        this.fetchStoreList()
      }
    },

    async fetchStoreList(params = {}) {
      try {
        const res = await fetchStoreList({
          ...params,
          limit: 50
        })
        this.storeList = _.get(res, ['data', 'data']) || []
        this.remoteLoading = false
        console.log(this.storeList)
      } catch (e) {
        console.log(e)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  @import '../../styles/dialog-form.scss';
</style>
